import { Injectable } from '@angular/core';
import { MantenimientoExpedicionesFilters } from '../models/mantenimiento-expediciones-filters.model';
import { MantenimientoCertificadosFilters } from '../models/mantenimiento-certificados-filters.models';

@Injectable()
export class ExpedicionesContextService {
    public mantenimientoExpedicionesFilters: MantenimientoExpedicionesFilters;
    public mantenimientoCertificadosFilters: MantenimientoCertificadosFilters;
}